import React from 'react';
import { Image } from '../../../components/Image';
// import Image from 'next/image';

// import iconPdf from './ic_pdf.png';
import styles from './Overall.module.scss';

interface IProps {
  title: string;
  date: string;
  link: string;
  expand?: boolean;
}

function OverallPdfCard(props: IProps) {
  const { title, date, link, expand = false } = props;

  const containerCls = expand ? styles.containerExpand : styles.container;
  const headerCls = expand ? styles.headerRow : styles.headerCol;
  const dateCls = expand ? styles.dateExpand : styles.date;

  return (
    <a href={link} className={containerCls} target="_blank" rel="noreferrer">
      <div className={headerCls}>
        <div className={styles.image}>
          <Image src="https://p0.meituan.net/smartvenus/8080974872c772f50926404b0ae0ce5e1804.png" layout="fill" />
        </div>
        <span className={styles.title}>{title}</span>
      </div>

      <p className={dateCls}>{date}</p>
    </a>
  );
}

export { OverallPdfCard };
